import Icons from "@/src/components/Icons";
import { useNavigate } from "react-router-dom";
import FilterDays from "./FilterDays";
import { useOrderStore } from "@/src/store/useOrderStore";
import { useEffect, useState } from "react";
import { reportApi } from "@/src/utils/api/report";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import moment from "jalali-moment";

function ReportArchive() {
  let history = useNavigate();
  const { setOrder, setRoute } = useOrderStore();
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);

  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);

  const [data, setData] = useState<any>([]);
  const [from, setFrom] = useState<number>(startOfToday.getTime());
  const [to, setTo] = useState<number>(endOfToday.getTime());
  const [showFilter, setShowFilter] = useState<string>("امروز");
  useEffect(() => {
    reportApi.archive(from, to).then((res) => {
      setData(res.data);

      console.log(res.data);
    });
  }, [from, to]);
  return (
    <div>
      <h4
        className="title text-xl font-extrabold flex items-center cursor-pointer"
        onClick={() => history("/report")}
      >
        <Icons name="arrowBack" fill="none" size={40} />
        آرشیو سفارش‌ها
      </h4>
      <FilterDays
        setFrom={setFrom}
        setTo={setTo}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
      />
      <div className="flex flex-col gap-4 mt-4">
        {data &&
          data.length > 0 &&
          data.map((item: any) => {
            return (
              <div
                className={`item rounded-xl  shadow-mmpz min-h-[78px] border p-3 relative cursor-pointer border-gray-100-mmpz`}
                onClick={() => {
                  setOrder(item);
                  setRoute("archive");
                  history("/report/order/details");
                }}
              >
                <h6 className={`text-lg font-bold max-one-line pe-10 `}>{item.name}</h6>
                <div className="shadow-mmpz p-2 w-fit text-xs mt-2 text-gray-200-mmpz rounded-xl flex items-center gap-1">
                  <Icons name="date" fill="none"  size={16}/>
                  {digitsEnToFa(
                    moment(item.deliveryDate).format("jYYYY-jMM-jDD dddd")
                  )}
                </div>
                <div className=" flex gap-2 items-center justify-between  mt-2 w-full">
                  <div className="rounded shadow-mmpz p-2 gap-4 flex items-center">
                    <span className="flex items-center gap-2 text-sm font-bold py-1">
                      <Icons name="checked" /> مبلغ کل سفارش
                    </span>
                    <span className="flex items-center gap-2  text-sm text-gray-300-mmpz">
                      <b>{digitsEnToFa(addCommas(item.sumPrice))}</b>{" "}
                      <small>تومان</small>
                    </span>
                  </div>
                </div>
                <div className="absolute top-2 left-2 flex items-center gap-2">
                  <span>
                    {item && item.hub && <Icons name={"hubIcon"} size={24} />}
                  </span>
                  <span>
                    <Icons name="moreIcon" size={30} />
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default ReportArchive;
